<template>
    <div class="limiter">
        <div class="container-login100">
            <div class="wrap-login100">
                <v-container fluid>
                    <v-row align="center" justify="center">
                        <v-card  class="login100-form" flat style="border-radius: 15px">
                            <span class="login100-form-title">
                                <img src="../assets/logoAiPay.jpeg" width="250px">
                            </span>
                            <v-card-text>
                                <v-layout row wrap justify-center>
                                    <v-flex xs10 sm10 lg9>
                                        <v-text-field
                                            color="#2C2E83"
                                            light
                                            label="E-mail"
                                            single-line
                                            outlined
                                            dense
                                            v-model="user.email"
                                            name="email"
                                            type="text"
                                            :rules="emailRules"
                                            required
                                            prepend-inner-icon="email"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs10 sm10 lg9>
                                        <v-text-field
                                            color="#2C2E83"
                                            label="Senha"
                                            single-line
                                            outlined
                                            dense
                                            v-model="user.password"
                                            name="password"
                                            :rules="passwordRules"
                                            required
                                            prepend-inner-icon="lock"
                                            :append-icon="show1 ? 'visibility' : 'visibility_off'"
                                            :type="show1 ? 'text' : 'password'"
                                            @click:append="show1 = !show1"
                                            @keydown.enter="signin"
                                        />
                                    </v-flex>
                                    <v-flex xs10 sm10 lg9 v-if="!usuarioLogado">
                                        <v-btn dark :loading="loading" depressed block color="#2C2E83" style="border-radius: 7px;" large @click="signin">Acessar</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                            <!-- <v-card-actions>
                                <v-layout row wrap justify-center>
                                    <v-flex xs10 sm10 lg9 v-if="!usuarioLogado">
                                        <v-btn dark depressed block color="#424f4e" style="border-radius: 7px;" large @click="signin">Acessar</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions> -->
                        </v-card>
                    </v-row>
                    <br>
                    <div class="login100-form-title">
                        <a href="https://www.intelitetecnologia.com.br/" target="_blank">
                            <img src="../assets/LogoBrancoHorizontal.png" width="130px">
                        </a>
                    </div>
                </v-container>
			</div>
		</div>
    <Snackbar ref=chamaSnackbar />
	</div>
</template>

<script>
    import { userKey, baseApiUrl } from '@/global'
    import Snackbar from '../componentes/snackbar.vue'
    import { mapState } from 'vuex'
    import axios from 'axios'
    export default {
        components: {Snackbar},
        name: 'Auth',

        computed: mapState({
            usuarioLogado: state => state.isMenuVisible,
        }),

        data: function() {
            return {
                loading: false,
                countAccess: '',
                userObj: [],
                show1: false,
                token: "",
                userId: "",
                showSignup: false,
                showAlterPass: false,
                userPemission: "",
                user: {},
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+/.test(v) || 'E-mail não é válido'
                ],
                nameRules: [
                    v => !!v || 'Nome é obrigatório'
                ],
                passwordRules: [
                    v => !!v || 'Senha é obrigatório'
                ],
            }
        },

        mounted: function () {
            if (sessionStorage.getItem('accToken') != null)
                this.$router.push({ path: '/home' })

            if (sessionStorage.getItem('userPermission') != null)
                this.$store.dispatch('Permission')

            if(sessionStorage.getItem('accToken') != null)                    
                this.$store.dispatch('Logar', this.token)
        },

        methods: {
            async signin() {
                var vm = this
                this.loading = true
                if ((this.user.email != null) || (this.user.password != null)) {
                    await axios.post(`${baseApiUrl}Usuarios/login`, this.user)
                    .then(res => {
                        this.token = res.data.id
                        this.userId = res.data.userId
                        this.VerficiaAdmin()
                    })
                    .catch(() => {
                        this.loading = false
                        vm.$refs.chamaSnackbar.snack("#EF5350","Usuário e Senha inválidos, corrija e tente novamente!","ERRO")
                    })
                } else {
                    this.loading = false
                    vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos de Login e Senha!","ATENÇÃO")
                }
            },

            /* signup() {
                var vm = this
                if ((this.user.email != null) || (this.user.username != null) || (this.user.password != null)) {
                    this.$http.post('Usuarios', this.user)
                    .then(() => {
                        this.user = {}
                        this.showSignup = false
                    })
                    .catch(() => {
                        //
                    })
                } else {
                    vm.$refs.chamaSnackbar.snack("warning","Preencha os campos obrigatórios!")
                }
            }, */

            Sair() {
                this.$store.dispatch('Sair')
            },   
            
            /* async contabilizaAcesso() {
                if (this.userId != '') {
                    this.countAccess = parseInt(this.countAccess) + 1
                    await axios.patch(`${baseApiUrl}Usuarios/${this.userId}?access_token=${this.token}`, {"ultimoAcesso" : new Date().toLocaleString(), "countAccesses" : this.countAccess} )
                }
            }, */

            async VerficiaAdmin() {
                if (this.userId != '') {
                    await axios.get(`${baseApiUrl}Usuarios/${this.userId}?access_token=${this.token}`)
                    .then(res => {
                        if (res.data.tipo === "GERENTE" || res.data.tipo === "ADMIN" || res.data.tipo === "CHECKIN" || res.data.tipo === "CHECKOUT" || res.data.tipo === "TOTEM" && res.data.ativo === true) {
                            sessionStorage.setItem('accToken', this.token)
                            this.$store.dispatch('Logar', this.token)
                            this.userPemission = res.data.tipo
                            this.user.username = res.data.nome
                            this.userObj = res.data
                            if (res.data.countAccesses == null)
                                this.countAccess = 0
                            else
                                this.countAccess = res.data.countAccesses
                            sessionStorage.setItem(userKey, JSON.stringify(this.userPemission))
                            sessionStorage.setItem('userPermission', this.userPemission)
                            sessionStorage.setItem('userName', this.user.username)
                            sessionStorage.setItem('user', JSON.stringify(res.data))
                            this.$store.dispatch('SetUser')
                            this.$store.dispatch('Permission')
                            this.$store.dispatch('SetUserName')
                            if (res.data.tipo === 'TOTEM') {
                                this.$router.push({ path: '/totem' })
                            } else {
                                this.$router.push({ path: '/home' })
                            }
                            if (res.data.tipo != 'ADMIN') {
                                this.verificaCompany()
                            }
                            //this.contabilizaAcesso()
                        } else {
                            this.loading = false
                            var vm = this
                            vm.$refs.chamaSnackbar.snack("warning","Usuário inativo ou sem permissão de acesso!")
                        }
                    })
                    .catch(() => {
                        //
                    })
                }
            },
                
            verificaCompany() {
                axios.get(`${baseApiUrl}Empresas?filter[where][id]=${this.userObj.empresaId}&access_token=${this.token}`)
                .then(res => {
                    sessionStorage.setItem('company', JSON.stringify(res.data[0]))
                    this.$store.dispatch('SetCompany')
                    this.loading = false
                })
                .catch(() => {
                    this.loading = false
                    var vm = this
                    vm.$refs.chamaSnackbar.snack("error","Erro ao consultar empresa")
                })
            },
        }
    }
</script>

<style>
    /* LOGIN */
    .limiter {
        width: 100%;
        margin: 0 auto;
    }

    .container-login100 {
        width: 100%;
        min-height: 100vh;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        padding: 15px;
        background: linear-gradient(to right, #2C2E83, #26B9ED);
        background-repeat: no-repeat;
        position: relative;
        z-index: 1;
    }

    .wrap-login100 {
        width: 400px;
        overflow: hidden;
        background: transparent;
    }

    /* [ Form ] */
    .login100-form {
        max-width: 90%;
        border-radius: 15px;
        background-color: #fff;
        opacity: 0.9;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .login100-form-title {
        display: block;
        margin-left: auto;
        margin-right: auto;
        text-align: center
    }

    .linkapp {
        text-decoration: none;
        color: white;
        font-size: 9px;
    }
</style>
